var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFlashOnGradient24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0033AD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M.333.667v14.666h4v12l9.334-16H8.333L13.667.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlashOnGradient24Px);
export default __webpack_public_path__ + "static/media/ic-flash-on-gradient-24-px.bd06aba2e83b2e41fc0c7e6e1b06c3bd.svg";
export { ForwardRef as ReactComponent };